/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import { isEmpty } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import CommandTemplatesApi from 'client/api/v2/CommandTemplatesApi';

export class CommandTemplateCollectionClass extends CollectionModule {
  constructor(os = '', ...args) {
    super(...args);
    this.os = os.toLowerCase();
  }

  extractModule() {
    const module = super.extractModule();

    module.getters.getFilterBackUp = (...params) => this
      .getFilterBackUp(...params);

    module.actions.setProviderId = (...params) => this
      .setProviderId(...params);

    module.actions.setOrganizationId = (...params) => this
      .setOrganizationId(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------
  getInitialState() {
    const state = super.getInitialState();

    // Adding if statement for allowing a cross-platform collection if none is specified
    if (this.os) {
      const filter = {
        name: 'commandType', operator: 'eq', value: this.os,
      };
      state.features.items.filters = [filter];
      state.features.items.filterBackUp = filter;
    }

    return state;
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  getFilterBackUp(state) {
    return state.features.items.filterBackUp;
  }
  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  /**
   * Overriding the parent's function so that we can filter by osSystem.
   * The filtering is done entirely in the UI.
   * @param context
   * @param next
   * @returns {Promise<unknown>}
   */
  fetchCollection(context, { next = false } = {}) {
    const filters = context.getters.getFilters;
    const filter = context.getters.getFilterBackUp;
    if (isEmpty(filters) && filter) {
      context.commit('SET_FILTER', { filter });
    }
    return super.fetchCollection(context, { next });
  }

  /**
   * @description Set a providerId for this collection.
   */
  setProviderId(context, providerId) {
    this.Api.setProviderId(providerId);
  }

  /**
   * @description Set a organizationId for this collection.
   */
  setOrganizationId(context, organizationId) {
    this.Api.setOrganizationId(organizationId);
  }
}

export function createCommandTemplateCollectionClass(os) {
  return new CommandTemplateCollectionClass(os, CommandTemplatesApi, 'id', 'name').extractModule();
}
